export default "__VITE_ASSET__D2M$mtAj__"